import { Button, Container, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

export function ErrorMessage({
  title = "Error",
  message = "Ha ocurrido un error",
}) {
  const navigate = useNavigate();

  return message ? (
    <Container sx={{ padding: 4 }}>
      <Typography variant="h4">{title}</Typography>

      <Typography variant="body1">{message}</Typography>

      <Stack direction="row" justifyContent="right">
        <Button
          variant="contained"
          onClick={() => {
            navigate(-1, { replace: true });
          }}
        >
          Volver atrás
        </Button>
      </Stack>
    </Container>
  ) : null;
}
